import CmChangePicture from '../cm-change-pictures/cm-change-picture.entity';
import { DEPARTMENTS } from '../enums/enums';
import HaLookPicture from '../ha-look-pictures/ha-look-picture.entity';
import MuLookPicture from '../mu-look-pictures/mu-look-picture.entity';
import Picture from '../pictures/picture.entity';
import { SosListResponse } from '../sos-response';

export interface DeptSpecificChangeLookPictureListResponse<
	T extends DEPARTMENTS
> extends SosListResponse {
	listed: T extends DEPARTMENTS.CM
		? {
				CmChangePicture: CmChangePicture[];
				Picture: Picture[];
		  }
		: T extends DEPARTMENTS.HA
		? {
				HaLookPicture: HaLookPicture[];
				Picture: Picture[];
		  }
		: T extends DEPARTMENTS.MU
		? {
				MuLookPicture: MuLookPicture[];
				Picture: Picture[];
		  }
		: never;
}

export type ChangeLookPictureListResponse =
	| DeptSpecificChangeLookPictureListResponse<DEPARTMENTS.CM>
	| DeptSpecificChangeLookPictureListResponse<DEPARTMENTS.HA>
	| DeptSpecificChangeLookPictureListResponse<DEPARTMENTS.MU>;

export interface ChangeLookPictureForEpCharListResponse
	extends SosListResponse {
	listed: {
		CmChangePicture?: CmChangePicture[];
		HaLookPicture?: HaLookPicture[];
		MuLookPicture?: MuLookPicture[];
	};
}
